import styled from 'styled-components'

import typeStyle from '../../../styles/typeStyle'

import { Content } from '../../cards/shared/styled'

interface ArrowLeft {
  left: boolean
  right?: never
}

interface ArrowRight {
  right: boolean
  left?: never
}

type ArrowOptions = ArrowLeft | ArrowRight

export const Arrow = styled.button.attrs({ type: 'button' })<ArrowOptions>`
  height: 40px;
  width: 40px;
  padding: 0;
  color: ${({ theme }) => theme.brand.forest};

  ${({ left }) =>
    left &&
    `
    left: 8px;

    svg {
      margin-left: -2px;
    }
  `}

  ${({ right }) =>
    right &&
    `
    right: 8px;
    svg {
      margin-right: -2px;
    }
  `}

  appearance: none;
  outline: 0;
  border: none;
  background-color: white;

  svg {
    display: inline-block;
    vertical-align: middle;
    height: 13px;
    margin-top: -2px;

    transform: rotate(${({ left }) => (left ? '90deg' : '-90deg')});
  }

  ${({ disabled }) =>
    disabled &&
    `
    color: #999;
  `}
`

/* Reserved only until slides load, so lazy content can't shift the page. */
export const Inner = styled.div<{ $minHeight?: string }>`
  min-height: ${({ $minHeight = '600px' }) => $minHeight};
  ${Content} {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  /* The header owns the title→carousel gap; neutralise the title block's own
     bottom margin (the title itself, or a nested subtitle) so it never stacks. */
  & > :first-child,
  & > :first-child > :last-child {
    margin-bottom: 0;
  }
`

export const Title = styled.h1`
  ${typeStyle('-ds-font-section-title-emphasised')}
  margin: 0;
  color: ${({ theme }) => theme.brand.forest};

  & * {
    font-style: normal;
    color: ${({ theme }) => theme.brand.forest};
  }
  & *:hover {
    font-style: normal;
    color: ${({ theme }) => theme.brand.forest};
  }
`
